import * as Constants from '../../lib/constants'
import * as Types from '../mutation-types'

const state = {
  currentMapCenter: [0, 0],

  currentMapTaskColoredMode: Constants.MAP_TASK_COLORED_MODE_NONE,
  currentGaugeValue: [{ min: 0, max: 0 }],
  altitudeGaugeValues: [{ min: 0, max: 0 }],
  speedGaugeValues: [{ min: 0, max: 0 }],

  // googlemap
  fieldGeoJsons: { type: 'FeatureCollection', features: [] },
}

const getters = {
  currentMapCenter: state => state.currentMapCenter,
  currentMapTaskColoredMode: state => state.currentMapTaskColoredMode,
  currentGaugeValue: state => state.currentGaugeValue,
  gaugeValues: state => {
    if (state.currentMapTaskColoredMode === Constants.MAP_TASK_COLORED_MODE_ALTITUDE) {
      return state.altitudeGaugeValues
    }
    if (state.currentMapTaskColoredMode === Constants.MAP_TASK_COLORED_MODE_SPEED) {
      return state.speedGaugeValues
    }
    return null
  },
  fieldGeoJsons: state => state.fieldGeoJsons,
}

const mutations = {
  [Types.SET_MAP_CENTER](state, centerBounds) {
    state.currentMapCenter = centerBounds
  },
  [Types.CHANGE_MAP_TASK_COLORED_MODE](state, mode) {
    state.currentMapTaskColoredMode = mode
    if (state.currentMapTaskColoredMode === Constants.MAP_TASK_COLORED_MODE_ALTITUDE) {
      state.currentGaugeValue = state.altitudeGaugeValues
    }
    if (state.currentMapTaskColoredMode === Constants.MAP_TASK_COLORED_MODE_SPEED) {
      state.currentGaugeValue = state.speedGaugeValues
    }
  },
  [Types.SET_GAUGE_VALUES](state, gaugeValues) {
    state.altitudeGaugeValues = gaugeValues.altitude
    state.speedGaugeValues = gaugeValues.speed
  },
  //google map
  [Types.SET_FIELD_GEO_JSONS](state, fieldGeoJsons) {
    state.fieldGeoJsons = fieldGeoJsons
  },
}

const actions = {
  changeMapTaskColoredMode({ commit }, mode) {
    commit(Types.CHANGE_MAP_TASK_COLORED_MODE, mode)
  },
  setGaugeValues({ commit }, gaugeValues) {
    commit(Types.SET_GAUGE_VALUES, gaugeValues)
  },
  // google map
  setFieldGeoJsons({ commit }, fieldGeoJsons) {
    commit(Types.SET_FIELD_GEO_JSONS, fieldGeoJsons)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
